export default {
  enums: [
    { id: 'DONATION', },
    { id: 'STATE_ENTERPRISE', },
    { id: 'NO_RETAIL_USE', },
  ]
}; 